import React from 'react'

const NLNewsFeed = (props) => {
  if (!props.newsFeed) return null
  return (
    <div dangerouslySetInnerHTML={{ __html: props.newsFeed }} />
  )
}

export default NLNewsFeed



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/nlNewsFeed.jsx